const stateNames = {
  NW: 'Nordrhein-Westfalen',
  BY: 'Bayern',
  BW: 'Baden-Württemberg',
  NI: 'Niedersachsen',
  HE: 'Hessen',
  RP: 'Rheinland-Pfalz',
  BE: 'Berlin',
  SH: 'Schleswig-Holstein',
  HH: 'Hamburg',
  SN: 'Sachsen',
  ST: 'Sachsen-Anhalt',
  SL: 'Saarland',
  BB: 'Brandenburg',
  TH: 'Thüringen',
  HB: 'Bremen',
  MV: 'Mecklenburg-Vorpommern',
};

export function mapStateIdToName(id: string): string {
  return stateNames[id] || '';
}
